// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.properties.multiplex.RentalManagerUserPropertyMultiplexWebApiHandler

import type { QueryOptions, UseMutationOptions, UseQueryOptions } from '@zg-rentals/react-query5';
import { useMutation, useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  RentalManagerUserPropertyMultiplexWebApiHandler_archive,
  RentalManagerUserPropertyMultiplexWebApiHandler_create,
  RentalManagerUserPropertyMultiplexWebApiHandler_createBuildingSession,
  RentalManagerUserPropertyMultiplexWebApiHandler_details,
  RentalManagerUserPropertyMultiplexWebApiHandler_details_Path,
  RentalManagerUserPropertyMultiplexWebApiHandler_getUnitNumbers,
  RentalManagerUserPropertyMultiplexWebApiHandler_getUnitNumbers_Path,
  RentalManagerUserPropertyMultiplexWebApiHandler_overview,
  RentalManagerUserPropertyMultiplexWebApiHandler_overview_Path,
  RentalManagerUserPropertyMultiplexWebApiHandler_unarchive,
  RentalManagerUserPropertyMultiplexWebApiHandler_unitPublished,
  RentalManagerUserPropertyMultiplexWebApiHandler_unitPublished_Path,
  RentalManagerUserPropertyMultiplexWebApiHandler_units,
  RentalManagerUserPropertyMultiplexWebApiHandler_units_Path,
  RentalManagerUserPropertyMultiplexWebApiHandler_upload,
} from '@zg-rentals/ts-rental-manager-api-client';

import type {
  ListingAlias,
  UserPropertyMultiplexArchiveRequestWebDto,
  UserPropertyMultiplexCreateBuildingSessionRequestWebDto,
  UserPropertyMultiplexCreateBuildingSessionResponseWebDto,
  UserPropertyMultiplexCreateUnitsRequestWebDto,
  UserPropertyMultiplexCreateUnitsResponseWebDto,
  UserPropertyMultiplexGetBuildingSessionDetailsResponseWebDto,
  UserPropertyMultiplexGetBuildingSessionOverviewResponseWebDto,
  UserPropertyMultiplexGetUnitNumbersResponseWebDto,
  UserPropertyMultiplexPhotoUploadRequestWebDto,
  UserPropertyMultiplexPhotoUploadResponseWebDto,
  UserPropertyMultiplexUnarchiveRequestWebDto,
  UserPropertyMultiplexUnitPublishedResponseWebDto,
  UserPropertyMultiplexUnitsResponseWebDto,
} from '@zg-rentals/ts-rental-manager-api-client';

interface DetailsParams {
  listingAlias?: ListingAlias;
  multiplexBuildingSessionId: string;
}
interface GetUnitNumbersParams {
  fullAddress: string;
}
interface OverviewParams {
  listingAlias?: ListingAlias;
  multiplexBuildingSessionId: string;
}
interface UnitPublishedParams {
  listingAlias: ListingAlias;
  multiplexBuildingSessionId: string;
}
interface UnitsParams {
  groupId: string;
  includeArchived?: boolean;
  includeUnarchived?: boolean;
  limit?: number;
  startKeyExclusive?: string;
}
interface UploadParams {
  multiplexBuildingSessionId: string;
}

export interface RentalManagerUserPropertyMultiplexWebApiHandler_archive_Args {
  postData: UserPropertyMultiplexArchiveRequestWebDto;
}

export type RentalManagerUserPropertyMultiplexWebApiHandler_archive_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyMultiplexWebApiHandler_archive_Args
>;

/**
 * Archive all units in a multiplex property
 */
export const useRentalManagerUserPropertyMultiplexWebApiHandler_archive = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyMultiplexWebApiHandler_archive_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyMultiplexWebApiHandler_archive_Args) =>
      RentalManagerUserPropertyMultiplexWebApiHandler_archive(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyMultiplexWebApiHandler_create_Args {
  postData: UserPropertyMultiplexCreateUnitsRequestWebDto;
}

export type RentalManagerUserPropertyMultiplexWebApiHandler_create_Options = UseMutationOptions<
  UserPropertyMultiplexCreateUnitsResponseWebDto,
  unknown,
  RentalManagerUserPropertyMultiplexWebApiHandler_create_Args
>;

/**
 * Create units for a multiplex
 */
export const useRentalManagerUserPropertyMultiplexWebApiHandler_create = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyMultiplexWebApiHandler_create_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyMultiplexWebApiHandler_create_Args) =>
      RentalManagerUserPropertyMultiplexWebApiHandler_create(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyMultiplexWebApiHandler_createBuildingSession_Args {
  postData: UserPropertyMultiplexCreateBuildingSessionRequestWebDto;
}

export type RentalManagerUserPropertyMultiplexWebApiHandler_createBuildingSession_Options = UseMutationOptions<
  UserPropertyMultiplexCreateBuildingSessionResponseWebDto,
  unknown,
  RentalManagerUserPropertyMultiplexWebApiHandler_createBuildingSession_Args
>;

/**
 * Create a multiplex building session from a list of property-only units
 */
export const useRentalManagerUserPropertyMultiplexWebApiHandler_createBuildingSession = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyMultiplexWebApiHandler_createBuildingSession_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyMultiplexWebApiHandler_createBuildingSession_Args) =>
      RentalManagerUserPropertyMultiplexWebApiHandler_createBuildingSession(args.postData, httpClient),
  });
};

export type RentalManagerUserPropertyMultiplexWebApiHandler_details_Options = UseQueryOptions<
  UserPropertyMultiplexGetBuildingSessionDetailsResponseWebDto,
  unknown,
  UserPropertyMultiplexGetBuildingSessionDetailsResponseWebDto,
  readonly [string, DetailsParams]
>;

const RentalManagerUserPropertyMultiplexWebApiHandler_details_GetKey = (getParams: DetailsParams) =>
  [RentalManagerUserPropertyMultiplexWebApiHandler_details_Path, getParams] as const;

export const RentalManagerUserPropertyMultiplexWebApiHandler_details_queryOptions = (
  getParams: DetailsParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerUserPropertyMultiplexWebApiHandler_details_GetKey(getParams),
    queryFn: () => RentalManagerUserPropertyMultiplexWebApiHandler_details(getParams, httpClient),
  }) as const satisfies QueryOptions;

/**
 * Get property details for a multiplex building session
 */
export const useRentalManagerUserPropertyMultiplexWebApiHandler_details = (
  getParams: DetailsParams,
  {
    httpClient,
    ...options
  }: Omit<RentalManagerUserPropertyMultiplexWebApiHandler_details_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...RentalManagerUserPropertyMultiplexWebApiHandler_details_queryOptions(getParams, { httpClient }),
    ...options,
  });
};
useRentalManagerUserPropertyMultiplexWebApiHandler_details.getKey =
  RentalManagerUserPropertyMultiplexWebApiHandler_details_GetKey;

export type RentalManagerUserPropertyMultiplexWebApiHandler_getUnitNumbers_Options = UseQueryOptions<
  UserPropertyMultiplexGetUnitNumbersResponseWebDto,
  unknown,
  UserPropertyMultiplexGetUnitNumbersResponseWebDto,
  readonly [string, GetUnitNumbersParams]
>;

const RentalManagerUserPropertyMultiplexWebApiHandler_getUnitNumbers_GetKey = (getParams: GetUnitNumbersParams) =>
  [RentalManagerUserPropertyMultiplexWebApiHandler_getUnitNumbers_Path, getParams] as const;

export const RentalManagerUserPropertyMultiplexWebApiHandler_getUnitNumbers_queryOptions = (
  getParams: GetUnitNumbersParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerUserPropertyMultiplexWebApiHandler_getUnitNumbers_GetKey(getParams),
    queryFn: () => RentalManagerUserPropertyMultiplexWebApiHandler_getUnitNumbers(getParams, httpClient),
  }) as const satisfies QueryOptions;

/**
 * Get unit numbers for a multiplex
 */
export const useRentalManagerUserPropertyMultiplexWebApiHandler_getUnitNumbers = (
  getParams: GetUnitNumbersParams,
  {
    httpClient,
    ...options
  }: Omit<RentalManagerUserPropertyMultiplexWebApiHandler_getUnitNumbers_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...RentalManagerUserPropertyMultiplexWebApiHandler_getUnitNumbers_queryOptions(getParams, { httpClient }),
    ...options,
  });
};
useRentalManagerUserPropertyMultiplexWebApiHandler_getUnitNumbers.getKey =
  RentalManagerUserPropertyMultiplexWebApiHandler_getUnitNumbers_GetKey;

export type RentalManagerUserPropertyMultiplexWebApiHandler_overview_Options = UseQueryOptions<
  UserPropertyMultiplexGetBuildingSessionOverviewResponseWebDto,
  unknown,
  UserPropertyMultiplexGetBuildingSessionOverviewResponseWebDto,
  readonly [string, OverviewParams]
>;

const RentalManagerUserPropertyMultiplexWebApiHandler_overview_GetKey = (getParams: OverviewParams) =>
  [RentalManagerUserPropertyMultiplexWebApiHandler_overview_Path, getParams] as const;

export const RentalManagerUserPropertyMultiplexWebApiHandler_overview_queryOptions = (
  getParams: OverviewParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerUserPropertyMultiplexWebApiHandler_overview_GetKey(getParams),
    queryFn: () => RentalManagerUserPropertyMultiplexWebApiHandler_overview(getParams, httpClient),
  }) as const satisfies QueryOptions;

/**
 * Get overview for a multiplex building session
 */
export const useRentalManagerUserPropertyMultiplexWebApiHandler_overview = (
  getParams: OverviewParams,
  {
    httpClient,
    ...options
  }: Omit<RentalManagerUserPropertyMultiplexWebApiHandler_overview_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...RentalManagerUserPropertyMultiplexWebApiHandler_overview_queryOptions(getParams, { httpClient }),
    ...options,
  });
};
useRentalManagerUserPropertyMultiplexWebApiHandler_overview.getKey =
  RentalManagerUserPropertyMultiplexWebApiHandler_overview_GetKey;

export interface RentalManagerUserPropertyMultiplexWebApiHandler_unarchive_Args {
  postData: UserPropertyMultiplexUnarchiveRequestWebDto;
}

export type RentalManagerUserPropertyMultiplexWebApiHandler_unarchive_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyMultiplexWebApiHandler_unarchive_Args
>;

/**
 * Unarchive all units in a multiplex property
 */
export const useRentalManagerUserPropertyMultiplexWebApiHandler_unarchive = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyMultiplexWebApiHandler_unarchive_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyMultiplexWebApiHandler_unarchive_Args) =>
      RentalManagerUserPropertyMultiplexWebApiHandler_unarchive(args.postData, httpClient),
  });
};

export type RentalManagerUserPropertyMultiplexWebApiHandler_unitPublished_Options = UseQueryOptions<
  UserPropertyMultiplexUnitPublishedResponseWebDto,
  unknown,
  UserPropertyMultiplexUnitPublishedResponseWebDto,
  readonly [string, UnitPublishedParams]
>;

const RentalManagerUserPropertyMultiplexWebApiHandler_unitPublished_GetKey = (getParams: UnitPublishedParams) =>
  [RentalManagerUserPropertyMultiplexWebApiHandler_unitPublished_Path, getParams] as const;

export const RentalManagerUserPropertyMultiplexWebApiHandler_unitPublished_queryOptions = (
  getParams: UnitPublishedParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerUserPropertyMultiplexWebApiHandler_unitPublished_GetKey(getParams),
    queryFn: () => RentalManagerUserPropertyMultiplexWebApiHandler_unitPublished(getParams, httpClient),
  }) as const satisfies QueryOptions;

/**
 * Get publish summary after a multiplex unit is published
 */
export const useRentalManagerUserPropertyMultiplexWebApiHandler_unitPublished = (
  getParams: UnitPublishedParams,
  {
    httpClient,
    ...options
  }: Omit<RentalManagerUserPropertyMultiplexWebApiHandler_unitPublished_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...RentalManagerUserPropertyMultiplexWebApiHandler_unitPublished_queryOptions(getParams, { httpClient }),
    ...options,
  });
};
useRentalManagerUserPropertyMultiplexWebApiHandler_unitPublished.getKey =
  RentalManagerUserPropertyMultiplexWebApiHandler_unitPublished_GetKey;

export type RentalManagerUserPropertyMultiplexWebApiHandler_units_Options = UseQueryOptions<
  UserPropertyMultiplexUnitsResponseWebDto,
  unknown,
  UserPropertyMultiplexUnitsResponseWebDto,
  readonly [string, UnitsParams]
>;

const RentalManagerUserPropertyMultiplexWebApiHandler_units_GetKey = (getParams: UnitsParams) =>
  [RentalManagerUserPropertyMultiplexWebApiHandler_units_Path, getParams] as const;

export const RentalManagerUserPropertyMultiplexWebApiHandler_units_queryOptions = (
  getParams: UnitsParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerUserPropertyMultiplexWebApiHandler_units_GetKey(getParams),
    queryFn: () => RentalManagerUserPropertyMultiplexWebApiHandler_units(getParams, httpClient),
  }) as const satisfies QueryOptions;

/**
 * Get units for a multiplex property
 */
export const useRentalManagerUserPropertyMultiplexWebApiHandler_units = (
  getParams: UnitsParams,
  {
    httpClient,
    ...options
  }: Omit<RentalManagerUserPropertyMultiplexWebApiHandler_units_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...RentalManagerUserPropertyMultiplexWebApiHandler_units_queryOptions(getParams, { httpClient }),
    ...options,
  });
};
useRentalManagerUserPropertyMultiplexWebApiHandler_units.getKey =
  RentalManagerUserPropertyMultiplexWebApiHandler_units_GetKey;

export interface RentalManagerUserPropertyMultiplexWebApiHandler_upload_Args {
  getParams: UploadParams;
  postData: UserPropertyMultiplexPhotoUploadRequestWebDto;
}

export type RentalManagerUserPropertyMultiplexWebApiHandler_upload_Options = UseMutationOptions<
  UserPropertyMultiplexPhotoUploadResponseWebDto,
  unknown,
  RentalManagerUserPropertyMultiplexWebApiHandler_upload_Args
>;

/**
 * Upload a photo to every unit in a multiplex building session
 */
export const useRentalManagerUserPropertyMultiplexWebApiHandler_upload = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyMultiplexWebApiHandler_upload_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyMultiplexWebApiHandler_upload_Args) =>
      RentalManagerUserPropertyMultiplexWebApiHandler_upload(args.getParams, args.postData, httpClient),
  });
};
